module.exports = __webpack_public_path__ + "media/app/components/CategoryNav/iconsNewDesign/128.31291091.svg";